import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=28678334&scoped=true"
import script from "./bus.vue?vue&type=script&lang=js"
export * from "./bus.vue?vue&type=script&lang=js"
import style0 from "./bus.vue?vue&type=style&index=0&id=28678334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28678334",
  null
  
)

export default component.exports